/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import uuid from 'uuid';
import { PDPAnalytics } from '../../../../analytics';
import TranslationUtil from '../../../../utils/translation';

const { getMessage } = TranslationUtil;
class TutorialCard extends Component {
    renderGuid= uuid.v4();

    componentDidMount() {
        const { tutorialCardConfig, sectionId } = this.props;
        PDPAnalytics.renderTutorialCard(tutorialCardConfig, sectionId, this.renderGuid);
    }

    onCardClick(e, tutorialCard) {
        const { actionHandlerCallback, sectionId } = this.props;
        const guid = uuid.v4();
        const actionParam = {
            actionObject: tutorialCard,
            guid,
        };
        actionHandlerCallback(
            e, sectionId, tutorialCard.actionId, actionParam
        );

        PDPAnalytics.tutorialCardClick(tutorialCard, guid, sectionId);
    }

    renderTutorialCardFooter() {
        const { tutorialCardConfig: { numOfTutorials, duration } } = this.props;
        const tutorialNumberId = numOfTutorials > 1 ? 'ccx.pdp.tutorial-card.tutorials-number'
            : 'ccx.pdp.tutorial-card.tutorial-number';
        const isValidNumOfTutorials = !!(numOfTutorials && numOfTutorials > 0);
        const isValidDuration = !!(duration && duration > 0);

        return (
            <div className="tutorial-card-details">
                {isValidNumOfTutorials && (
                    getMessage(tutorialNumberId,
                        { numOfTutorials })
                )}
                {isValidNumOfTutorials && isValidDuration && <span className="detail-separator">.</span>}
                {isValidDuration && (
                    getMessage('ccx.pdp.tutorial-card.duration',
                        { duration })
                )}
            </div>
        );
    }

    render() {
        const { tutorialCardConfig } = this.props;
        return (
            <div
                className="tutorial-card"
                render-guid={this.renderGuid}
                tabIndex={0}
                role="link"
                aria-label={`${tutorialCardConfig.description}, ${tutorialCardConfig.duration}m`}
                onClick={(e) => { this.onCardClick(e, tutorialCardConfig); }}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        this.onCardClick(e, tutorialCardConfig);
                    }
                }}>
                <div className="tutorial-card-image" style={{ backgroundImage: `url('${tutorialCardConfig.imageURL}')` }} />
                <div className="tutorial-card-desc">
                    <span className="tutorial-card-title">
                        {tutorialCardConfig.description}
                    </span>
                    {this.renderTutorialCardFooter()}
                </div>
            </div>
        );
    }
}

export default observer(TutorialCard);
